/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
class SogouSearchEngine {
    getSearchUrl(query, options) {
        const { count = 10, excludeDomains = [] } = options;
        const excludeDomainsQuery = excludeDomains && excludeDomains.length > 0 ? excludeDomains.map((domain)=>`-site:${domain}`).join(' ') : '';
        const searchParams = new URLSearchParams({
            query: `${excludeDomainsQuery ? `${excludeDomainsQuery} ` : ''}${query}`,
            num: `${count}`
        });
        return `https://www.sogou.com/web?${searchParams.toString()}`;
    }
    extractSearchResults(window) {
        const links = [];
        const document = window.document;
        const isValidUrl = (url)=>{
            try {
                new URL(url);
                return true;
            } catch (error) {
                return false;
            }
        };
        const BaseUrl = 'https://www.sogou.com';
        const SELECTOR = {
            results: '.results .vrwrap',
            resultTitle: '.vr-title',
            resultLink: '.vr-title > a',
            resultSnippet: [
                '.star-wiki',
                '.fz-mid',
                '.attribute-centent'
            ],
            resultSnippetExcluded: [
                '.text-lightgray',
                '.zan-box',
                '.tag-website'
            ],
            related: '#main .vrwrap.middle-better-hintBox .hint-mid'
        };
        try {
            const elements = document.querySelectorAll(SELECTOR.results);
            elements.forEach((element)=>{
                var _element_querySelector, _titleEl_textContent;
                const titleEl = element.querySelector(SELECTOR.resultTitle);
                let url = null === (_element_querySelector = element.querySelector(SELECTOR.resultLink)) || void 0 === _element_querySelector ? void 0 : _element_querySelector.getAttribute('href');
                const snippets = SELECTOR.resultSnippet.map((selector)=>{
                    var _el_textContent;
                    const cloneElement = element.cloneNode(true);
                    SELECTOR.resultSnippetExcluded.forEach((excludedSelector)=>{
                        const el = cloneElement.querySelector(excludedSelector);
                        null == el || el.remove();
                    });
                    const el = cloneElement.querySelector(selector);
                    return (null == el ? void 0 : null === (_el_textContent = el.textContent) || void 0 === _el_textContent ? void 0 : _el_textContent.trim()) || '';
                });
                const snippet = snippets.filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
                if (!(null == url ? void 0 : url.includes('http'))) url = `${BaseUrl}${url}`;
                if (!(null == url ? void 0 : url.trim()) || !isValidUrl(url)) return;
                const item = {
                    title: (null == titleEl ? void 0 : null === (_titleEl_textContent = titleEl.textContent) || void 0 === _titleEl_textContent ? void 0 : _titleEl_textContent.trim()) || '',
                    url,
                    snippet,
                    content: ''
                };
                if (!item.title || !item.url) return;
                links.push(item);
            });
        } catch (error) {
            const msg = error instanceof Error ? error.message : String(error);
            console.error('Error extracting search results from Sogou:', msg);
        }
        return links;
    }
    async waitForSearchResults(page) {
        await page.waitForSelector('#pagebar_container');
    }
}
export { SogouSearchEngine };

//# sourceMappingURL=sogou-engine.mjs.map